import { API_BASE_URL } from './api';
import { clearClientAuth, withoutPasswordFields, readJson } from '../utils/auditSafety';

// A UI revision, never a credential. Only the API validates the HttpOnly cookie.
export const getSessionVersion = () => localStorage.getItem('rcsSessionVersion');
export const hasClientSession = () => Boolean(getSessionVersion() && localStorage.getItem('user'));

export const saveSession = (response, newSession = true) => {
  const data = withoutPasswordFields(response);
  if (!data?.user || typeof data.user !== 'object' || Array.isArray(data.user)) {
    throw new Error('Sign-in could not be completed. Please try again.');
  }
  // Preserve department/range metadata used by existing screens when /me returns only user.
  let previous = {};
  try { previous = JSON.parse(localStorage.getItem('loginResponse') || '{}'); } catch { /* Replace invalid cache. */ }
  const sameUser = previous?.user && data.user.username && previous.user.username === data.user.username
    && previous.user.id === data.user.id && previous.user.role === data.user.role;
  if (newSession || !sameUser) { clearClientAuth(); previous = {}; }
  ['authToken', 'token', 'accessToken'].forEach(key => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
  localStorage.setItem('user', JSON.stringify(data.user));
  localStorage.setItem('loginResponse', JSON.stringify(withoutPasswordFields({ ...previous, ...data })));
  try {
    const others = typeof data.others === 'string' ? JSON.parse(data.others) : data.others;
    const range = data.user.detail?.range || others?.range;
    if (range) localStorage.setItem('rangeData', JSON.stringify(range));
  } catch { /* Optional metadata must not block sign-in. */ }
  if (newSession || !getSessionVersion()) localStorage.setItem('rcsSessionVersion', window.crypto.randomUUID());
  window.dispatchEvent(new Event('rcs-session-change'));
  return data;
};

export const restoreSession = async () => {
  const version = getSessionVersion();
  const response = await fetch(`${API_BASE_URL}/user/me`, { credentials: 'include', cache: 'no-store' });
  if (version !== getSessionVersion()) return hasClientSession();
  if (response.status === 401) { clearClientAuth(); return false; }
  if (!response.ok) throw new Error('Unable to verify your session. Please try again.');
  const data = await readJson(response);
  if (version !== getSessionVersion()) return hasClientSession();
  saveSession(data, false);
  return true;
};

export const logoutSession = async () => {
  const response = await fetch(`${API_BASE_URL}/logout`, { method: 'POST', credentials: 'include' });
  if (!response.ok && response.status !== 401) throw new Error('Unable to sign out. Please try again.');
  clearClientAuth();
};
